import { Pagination as MuiPagination, styled } from '@mui/material';
import { ChangeEvent } from 'react';
import { usePagination } from '@shared';

const StyledPagination = styled(MuiPagination)({
  ul: { justifyContent: 'center' },
});

type PropsType = {
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (value: number) => void;
  enhanced?: boolean;
  withoutParams?: boolean;
};

export const Pagination = ({
  totalPages,
  onPageChange,
  enhanced = false,
  currentPage,
}: PropsType) => {
  const [page, setPage, setSearchParams] = usePagination();

  const handlePageChange = (e: ChangeEvent<unknown>, value: number) => {
    setPage(value);

    onPageChange && onPageChange(value);
    setSearchParams((prevParams) => {
      const params = {
        offset: String(value),
      };
      return enhanced
        ? Object.assign(params, {
            limit: prevParams.get('limit') || '20',
            field: prevParams.get('field') || 'first_name',
            direction: prevParams.get('direction') || 'asc',
          })
        : params;
    });
  };
  return (
    <StyledPagination
      count={totalPages}
      page={currentPage || page}
      color='primary'
      variant='outlined'
      onChange={handlePageChange}
    />
  );
};
